import React from "react";
import { X } from "lucide-react";
import CourseDetail from "./CourseDetail";

interface CoursePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  slug: string;
}

export default function CoursePreviewModal({
  isOpen,
  onClose,
  slug,
}: CoursePreviewModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="min-h-screen px-4 text-center">
        {/* Close button */}
        <div className="fixed top-0 right-0 pt-4 pr-4 z-50">
          <button
            onClick={onClose}
            className="bg-white rounded-full p-2 hover:bg-gray-100 transition-colors duration-200 shadow-lg"
          >
            <X className="h-6 w-6 text-gray-600" />
          </button>
        </div>

        {/* Modal content */}
        <div className="inline-block w-full max-w-6xl my-8 text-left align-middle">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <CourseDetail previewMode={true} slug={slug} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
